<script>
export default {
  name: "PageTools",
  props: {
    total: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true,
      default: 1
    }
  },
  computed: {
    // 使用计算属性代替直接数据存储
    paginationCurrentPage: {
      get() {
        return this.currentPage
      },
      set(val) {
        this.$emit('page-change', val);
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.paginationCurrentPage = val
    }
  }
}
</script>

<template>
  <div class="pagination-wrapper">
    <el-pagination
        @current-change="handleCurrentChange"
        :current-page="paginationCurrentPage"
        :layout="total > 0 ? 'total, prev, pager, next' : 'prev, pager, next'"
        :total="total"
        prev-text="上一页"
        next-text="下一页">
    </el-pagination>
  </div>
</template>

<style scoped>
.pagination-wrapper {
  margin: 20px 0;
  text-align: center;
}
</style>
